<template>
  <div>
    <base-header class="pb-7 pt-5 pt-md-8 bg-gradient-warning">

    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--7">
      <!--Tables-->
      <b-row class="mt-5">
        <b-col xl="12" class="mb-5 mb-xl-0">
          <b-card no-body>
            <div role="tablist" class="accordion" v-if="weekState.products.length > 0">
              <b-card no-body class="mb-1" v-for="data in weekState.products" :key="data[0].key">
                <b-card-header header-tag="header" href="#" role="tab" v-b-toggle="'accordion-' + data[0].key">
                  <h4 class="mb-0" style="text-transform:capitalize;">{{ data[0].day }}</h4>
                </b-card-header>
                <b-collapse :id="'accordion-' + data[0].key" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <b-card-text>
                      <b-row v-for="totalPerDay in weekState.totals" :key="totalPerDay[0].key">
                        <b-col v-if="totalPerDay[0].day === data[0].day" v-for="total in totalPerDay" :key="total.title">
                          <stats-card :title="total.title"
                                      type="gradient-orange"
                                      :sub-title="total.quantity.toString()"
                                      icon="ni ni-chart-bar-32"
                                      class="mb-2">
                          </stats-card>
                        </b-col>
                      </b-row>
                      <el-table class="table-responsive table-flush"
                                header-row-class-name="thead-light"
                                :data="data">
                        <el-table-column label="Product"
                                         prop="title"
                                         min-width="140px"
                                         sortable>
                        </el-table-column>
                        <el-table-column label="Aantal"
                                         prop="quantity"
                                         min-width="140px"
                                         sortable>
                        </el-table-column>
                      </el-table>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <div v-else>
              <h4 class="text-center">Geen data beschikbaar</h4>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!--End tables-->
    </b-container>
  </div>
</template>
<style scoped>
  .accordion > .card .card-header {
    cursor: pointer;
    background-color: #f3f3f3;
  }
</style>
<script>
  // Components
  import StatsCard from '@/components/Cards/StatsCard';

  // Tables
  import { mapGetters } from 'vuex'
  import { Table, TableColumn} from 'element-ui'

  export default {
    components: {
      StatsCard,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
    },
    data() {
      return {
      };
    },
    computed: {
      ...mapGetters({
        weekState: 'orders/weekState',
      })
    },
    mounted(){
      this.$store.dispatch('orders/getWeekState')
    },
    methods: {

    }
  };
</script>
